import { useState } from 'react';

export const useForceUpdate = () => {
  const [forcedUpdateCounter, setState] = useState(0);
  return () => setState(forcedUpdateCounter + 1);
};
